import React, { Component } from 'react';
import Checkbox from 'rc-checkbox';
import { browserHistory } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { login } from '../../../../actions/userActions';
// import { trimUserInput } from '../../../../utils/formHelpers';

import 'rc-checkbox/assets/index.css';
import '../style.css';

const validate = formProps => {
  const errors = {};

  if (!formProps.email) {
    errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formProps.email)) {
    errors.email = 'Invalid email address';
  }

  if (!formProps.password) {
    errors.password = 'Password is required';
  } else if (formProps.password.length < 4) {
    errors.password = 'Must be 4 characters or more';
  }

  return errors;
};

const renderField = ({
  input,
  label,
  type,
  disabled,
  meta: { touched, error, warning }
}) => {
  let hasStatus = null;
  let message = null;

  // remove touched from first two tests to
  // force form validation on initial load
  if (touched && error) {
    hasStatus = 'danger';
    message = error;
  } else if (touched && warning) {
    hasStatus = 'warning';
    message = warning;
  } else if (touched) {
    hasStatus = 'success';
    message = null;
  } else {
    hasStatus = null;
    message = null;
  }

  return (
    <div className={`form-group ${hasStatus ? 'has-' + hasStatus : ''}`}>
      <div className={`input-wrapper rounded  ${hasStatus ? 'has-' + hasStatus : ''}`}>
        <div className="text-left px-4">
          <small>{label}</small>
        </div>
        <input
          id={input.name}
          className="form-control form-control-danger form-control-warning form-control-success border-0 px-4"
          {...input}
          disabled={disabled}
          type={type}
        />
      </div>
      {message ? (
        <div className="form-control-feedback">
          <small>{message}</small>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

class SignInForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      remember: true
    };
  }

  handleChangeremember = () => {
    this.setState({
      remember: !this.state.remember
    });
  }

  handleForgotPassword = () => {
    const { onForgotPassword } = this.props;

    browserHistory.replace('/forgot');
    onForgotPassword && onForgotPassword();
  }

  handleFormSubmit = (values) => {
    // clean up any user input
    // const userInput = trimUserInput(values);

    // pick off the values we want
    const { remember } = this.state;
    const { onSuccess, bookingData } = this.props;
    const { email, password } = values;

    return new Promise((resolve, reject) => {
      this.props.login(
        email,
        password,
        remember,
        bookingData,
        () => {
          resolve();
          onSuccess && onSuccess();
        },
        error => {
          reject(error);
        }
      );
    }).catch(ex => {
      throw new SubmissionError(ex);
    });
  }

  render() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;

    return (
      <form className="AuthForm SignInForm form" onSubmit={handleSubmit(this.handleFormSubmit)}>
        <Field
          name="email"
          component={renderField}
          type="email"
          label="Email"
          placeholder="Email"
        />

        <Field
          name="password"
          component={renderField}
          type="password"
          label="Password"
          placeholder="Password"
        />

        <div className="remember-me d-flex align-items-center justify-content-between my-3">
          <label className="m-0 btn-cursor">
            <Checkbox
              name="my-checkbox"
              checked={this.state.remember}
              onChange={this.handleChangeremember}
            />
            &nbsp; Remember me
          </label>
          <button
            type="button"
            className="btn btn-link btn-cursor px-0"
            onClick={this.handleForgotPassword}
          >
            Forgot Password?
          </button>
        </div>

        <button
          type="submit"
          className="btn btn-primary btn-lg btn-cursor w-100"
          disabled={pristine || submitting}
          data-qa-id="login-submit-button"
        >
          Login
        </button>

        {// if an error exists, render an Alert
          error && <p className="text-danger my-2">{error}</p>
        }
      </form>
    );
  }
}

export default compose(
  connect(
    null,
    { login }
  ),
  reduxForm({ form: 'signInForm', validate })
)(SignInForm);



// WEBPACK FOOTER //
// ./src/components/forms/Auth/SignInForm/index.js